import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { ExpertiseType } from '../ExpertisePage/types';
import PovsExpertisePage from '../PovsExpertisePage';

export const EditPovsExpertiseListPage = () => {
  const { id } = useParams();
  const [currentExpertise, setCurrentExpertise] = useState<ExpertiseType | undefined>();

  useEffect(() => {
    if (id)
      (async () => {
        try {
          const response = await api.get<ExpertiseType>(endpoints.getExpertiseById(id));

          setCurrentExpertise(response.data);
        } catch (err) {}
      })();
  }, [id]);

  return <PovsExpertisePage editExpertise={currentExpertise} edit />;
};
